import { ApplicationConfig, isDevMode, APP_INITIALIZER } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { appReducers, metaReducers } from './store';
import { AuthEffects } from './store/auth/auth.effects';
import { ErpModulesService } from './core/services/erp-modules.service';
import { TenantService } from './core/tenant/tenant.service';

function initErpModules(svc: ErpModulesService) {
  return () => svc.load().subscribe({ error: () => {} });
}

function initTenantContext(svc: TenantService) {
  // El propio servicio captura los errores (ver TenantService.cargarContexto),
  // así que esto nunca debe romper el arranque de la app.
  return () => svc.cargarContexto().subscribe();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideStore(appReducers, { metaReducers }),
    provideEffects([AuthEffects]),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    {
      provide: APP_INITIALIZER,
      useFactory: initErpModules,
      deps: [ErpModulesService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initTenantContext,
      deps: [TenantService],
      multi: true,
    },
  ]
};
